export default "__VITE_ASSET__Thgl1Lnp__"